var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-skeleton-item',{ref:"skeletonitem",class:_vm.className,attrs:{"variant":_vm.variant}})
}
var staticRenderFns = []

export { render, staticRenderFns }